// extracted by mini-css-extract-plugin
export var currencyInput = "_k9-1";
export var currencySymbol = "_k9-0";